import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FileText, PenSquare } from 'lucide-react';
import DashboardLayout, { NavCard } from '../../components/DashboardLayout';
import { usePerms } from '../../permissions/PermissionsContext';

/**
 * MerchantInvoicesHub — iter-264c (Feb 2026)
 * Sub-hub under "منصة التجار (المالية)" grouping invoice-CREATION screens.
 */
export default function MerchantInvoicesHub() {
  const navigate = useNavigate();
  const { visiblePages } = usePerms();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const items = [
    {
      id: 'create-invoice',
      titleAr: 'إنشاء فاتورة لمنصة التجار عام',
      titleEn: 'Create Invoice — Merchant Platform (General)',
      descAr: 'إنشاء فاتورة مباشرة وإرسالها للتاجر / العميل',
      descEn: 'Create a new invoice directly and send it to the merchant / customer',
      icon: FileText,
      route: '/dashboard/finance/create-invoice/cloudgm_merchants',
      color: '#10b981',
      screenCode: 'CGM-MERCH-INV-NEW',
      testId: 'card-create-invoice',
    },
    {
      id: 'create-agent-invoice',
      titleAr: 'إنشاء فاتورة للوكلاء',
      titleEn: 'Create Agent Invoice',
      descAr: 'ابحث عن وكيل مسجل واختر الخدمة الفرعية لإصدار فاتورة له',
      descEn: 'Search a registered agent, pick a sub-service, and issue an invoice',
      icon: PenSquare,
      route: '/dashboard/finance/create-invoice/agents',
      color: '#eab308',
      screenCode: 'CGM-AGENT-INV-NEW',
      testId: 'card-create-agent-invoice',
    },
  ];

  const containerVariants = {
    hidden:  { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };

  return (
    <DashboardLayout
      title="إنشاء الفواتير"
      titleEn="Create Invoices"
      subtitle="إنشاء فواتير عامة للتجار وفواتير خاصة بالوكلاء"
      subtitleEn="Create general merchant invoices and dedicated agent invoices"
      screenCode="FIN-CGM-MERCH-INV"
      backPath="/dashboard/finance/cloudgm/merchants"
      breadcrumb={[
        { labelAr: 'المالية',                labelEn: 'Finance',                     path: '/dashboard/finance' },
        { labelAr: 'CLOUDGM FZ LLC',         labelEn: 'CLOUDGM FZ LLC',              path: '/dashboard/finance/cloudgm' },
        { labelAr: 'منصة التجار (المالية)',  labelEn: 'Merchant Platform (Finance)', path: '/dashboard/finance/cloudgm/merchants' },
        { labelAr: 'إنشاء الفواتير',         labelEn: 'Create Invoices',             path: null },
      ]}
    >
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {visiblePages(items, 'route').map((item) => (
            <NavCard
              key={item.id}
              icon={item.icon}
              title={item.titleAr}
              titleEn={item.titleEn}
              description={item.descAr}
              descriptionEn={item.descEn}
              onClick={() => navigate(item.route)}
              color={item.color}
              screenCode={item.screenCode}
              testId={item.testId}
            />
          ))}
        </motion.div>
      </section>
    </DashboardLayout>
  );
}
